import { useState } from 'react'
import { supabase } from '../../lib/supabase'
import { useAuth } from '../../contexts/AuthContext'
import { useToast, humanizeError } from '../shared/Toast'

const RECURRENCE = [
  { value: 'FREQ=DAILY', label: 'Daily' },
  { value: 'FREQ=WEEKLY', label: 'Weekly' },
  { value: 'FREQ=MONTHLY', label: 'Monthly' },
]

export default function TaskForm({ recipientId, task, team, onDone, onCancel }) {
  const { user } = useAuth()
  const toast = useToast()
  const editing = !!task
  const [f, setF] = useState({
    title: task?.title || '',
    description: task?.description || '',
    assigned_to: task?.assigned_to || '',
    due_date: task?.due_date || '',
    is_recurring: task?.is_recurring || false,
    recurrence_rule: task?.recurrence_rule || 'FREQ=WEEKLY',
  })
  const [busy, setBusy] = useState(false)
  const set = (k, v) => setF((c) => ({ ...c, [k]: v }))

  async function save() {
    if (!f.title.trim()) return toast.error('Give the task a title.')
    setBusy(true)
    try {
      const payload = {
        title: f.title.trim(),
        description: f.description.trim() || null,
        assigned_to: f.assigned_to || null,
        due_date: f.due_date || null,
        is_recurring: f.is_recurring,
        recurrence_rule: f.is_recurring ? f.recurrence_rule : null,
      }
      const res = editing
        ? await supabase.from('tasks').update(payload).eq('id', task.id)
        : await supabase.from('tasks').insert({ ...payload, care_recipient_id: recipientId, created_by: user.id })
      if (res.error) throw res.error
      toast.success(editing ? 'Task updated.' : 'Task added.')
      onDone()
    } catch (err) {
      toast.error(humanizeError(err))
    } finally {
      setBusy(false)
    }
  }

  return (
    <div onClick={() => !busy && onCancel()} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 200, display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}>
      <div onClick={(e) => e.stopPropagation()} style={{ background: 'var(--bg)', width: '100%', maxWidth: 'var(--maxw)', borderTopLeftRadius: 20, borderTopRightRadius: 20, padding: 20, maxHeight: '92dvh', overflowY: 'auto' }}>
        <div className="spread" style={{ marginBottom: 12 }}>
          <h2 className="title" style={{ fontSize: 20 }}>{editing ? 'Edit task' : 'New task'}</h2>
          <button onClick={onCancel} style={{ background: 'none', border: 'none', fontSize: 22, color: 'var(--muted)' }}>✕</button>
        </div>
        <div className="stack">
          <div className="field"><label className="label">Title *</label><input className="input" value={f.title} onChange={(e) => set('title', e.target.value)} placeholder="e.g. Pick up prescription" /></div>
          <div className="field"><label className="label">Description</label><textarea className="textarea" value={f.description} onChange={(e) => set('description', e.target.value)} placeholder="Optional details" /></div>
          <div className="field">
            <label className="label">Assign to</label>
            <select className="select" value={f.assigned_to} onChange={(e) => set('assigned_to', e.target.value)}>
              <option value="">Unassigned</option>
              {team.map((m) => <option key={m.user_id} value={m.user_id}>{m.name}</option>)}
            </select>
          </div>
          <div className="field"><label className="label">Due date</label><input type="date" className="input" value={f.due_date} onChange={(e) => set('due_date', e.target.value)} /></div>
          <label className="row" style={{ gap: 10, cursor: 'pointer' }}>
            <input type="checkbox" checked={f.is_recurring} onChange={(e) => set('is_recurring', e.target.checked)} style={{ width: 20, height: 20 }} />
            <span className="grow">Recurring task</span>
          </label>
          {f.is_recurring && (
            <div className="row wrap" style={{ gap: 8 }}>
              {RECURRENCE.map((r) => (
                <button key={r.value} type="button" className={`chip ${f.recurrence_rule === r.value ? 'chip-on' : ''}`} onClick={() => set('recurrence_rule', r.value)}>{r.label}</button>
              ))}
            </div>
          )}
          <button className="btn btn-lg btn-block" onClick={save} disabled={busy}>{busy ? <span className="spinner" /> : editing ? 'Save changes' : 'Add task'}</button>
        </div>
      </div>
    </div>
  )
}
